import React from "react";
import { navigate } from "hookrouter";
import { Logo, sans } from "../../theme/brand";

const links = [
  { path: "/", label: "Home" },
  { path: "/diensten", label: "Diensten" },
  { path: "/over-ons", label: "Over ons" },
  { path: "/contact", label: "Contact" },
];

const footLink = {
  background: "none",
  border: "none",
  cursor: "pointer",
  fontFamily: sans,
  fontSize: 15.5,
  color: "#9DB0AE",
  padding: 0,
};

export default function AppFooter() {
  const year = new Date().getFullYear();

  return (
    <footer style={{ background: "#0F1A24", color: "#9DB0AE" }}>
      <div
        style={{
          maxWidth: 1120,
          margin: "0 auto",
          padding: "52px 32px",
          display: "flex",
          flexWrap: "wrap",
          gap: 28,
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
          <Logo size={24} />
          <span style={{ fontSize: 19, fontWeight: 700, color: "#EAF1EF" }}>Datails</span>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 20, alignItems: "center" }}>
          {links.map(({ path, label }) => (
            <button key={path} onClick={() => navigate(path)} style={footLink}>
              {label}
            </button>
          ))}
          <a href="mailto:info@datails.nl" style={{ color: "#6FBFAD", fontSize: 15.5, fontWeight: 600 }}>
            info@datails.nl
          </a>
        </div>
        <p
          style={{
            fontSize: 14,
            color: "#6A7A80",
            width: "100%",
            borderTop: "1px solid #22303B",
            paddingTop: 22,
          }}
        >
          © {year} Datails B.V. · Arnhem, Nederland · KVK 84900237 · BTW-nummer NL004038091B50
        </p>
      </div>
    </footer>
  );
}
